(function () {
  if (window.__industrySwitchBound) return;
  window.__industrySwitchBound = true;

  document.addEventListener('click', function (event) {
    var option = event.target.closest('.industry-switch__option');
    if (!option) return;
    var industry = option.getAttribute('data-industry');
    if (industry) {
      try { localStorage.setItem('HomeLayout', industry); } catch (e) {}
    }
  });
})();
